//swiper
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import ScrollAnime from "./anime/_scroll";
import Movie from "./classes/movie.es6";
import Modal from "./modal/_modal_swiper.es6";

export default class Main {
    constructor() {
        this._init();
    }

    _init() {
        this.scroll = new ScrollAnime();
        this.movie = new Movie();
        this.modal = new Modal();
        this.swiper();
    }

    swiper() {
        const swipers = [...document.querySelectorAll(".js-swiper")];

        //.swiperでクラスをつけないで、DOMそれぞれにswiperを作成
        swipers.forEach((el) => {
            const parent = el.closest(".js-swiper_wrap");
            const thumbs = parent && parent.querySelector(".js-swiper_thumb");

            if (thumbs) {
                const thumbSlider = new Swiper(thumbs, {
                    slidesPerView: "auto",
                    spaceBetween: 4,
                });

                const swiper = new Swiper(el, {
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    thumbs: {
                        swiper: thumbSlider,
                    },
                });
            } else {
                const swiper = new Swiper(el, {
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            }
        });
    }
}
